export const HOME_DIGITAL_TWIN = `/:tenantId`;
export const ROUTE_DIGITAL_TWIN = `/:tenantId/:digitalTwinId`;
export const ROUTE_ACCESS_CONTROL = `/:tenantId/access-control`;

export const getDigitalTwinUrl = (tenant: string, digitalTwinId: string) =>
  `/${tenant}/${digitalTwinId}`;

export const getDigitalTwinSchemaUrl = (
  tenant: string,
  digitalTwinId: string,
  schemaNameDT: string
) => `/${tenant}/${digitalTwinId}/schemas/${schemaNameDT}`;

export const getCollectionRunUrl = (
  tenant: string,
  digitalTwinId: string,
  collectionReportId: string
) => `/${tenant}/${digitalTwinId}/data-quality/${collectionReportId}`;

export const getConsistencyReportUrl = (
  tenant: string,
  digitalTwinId: string,
  consistencyReportId: string
) =>
  `/${tenant}/${digitalTwinId}/data-quality/consistency/${consistencyReportId}`;

export const getConsistencyRuleReportUrl = (
  tenant: string,
  digitalTwinId: string,
  consistencyReportId: string,
  ruleId: string
) =>
  `/${tenant}/${digitalTwinId}/data-quality/consistency/${consistencyReportId}/rule/${ruleId}`;
